class FavoritesApi {
    constructor(api, opts) {
        this.api = api;
        this.options = {
            withCredentials: true,
            ...opts,
        };
    }

    get(query = {}, page = null, count = null) {
        const finalQuery = {
            ...query,
        };
        if (page !== null) {
            finalQuery.page = null;
        }
        if (count !== null) {
            finalQuery.count = null;
        }
        return this.api.requestGet(this.api.route('favorites.get'), finalQuery, {
            withSession: true,
        });
    }

    createOrUpdate(data) {
        const { withCredentials } = this.options;
        return this.api.requestPost(this.api.route('favorites.createOrUpdate'), data, {
            withSession: !withCredentials,
            withCredentials,
        });
    }

    delete(data) {
        const { withCredentials } = this.options;
        return this.api.requestDelete(this.api.route('favorites.delete'), data, {
            withSession: !withCredentials,
            withCredentials,
        });
    }
}

export default FavoritesApi;
